module.exports = __webpack_public_path__ + "ipetbooking/admin/img/lineFriend_3.af12a6f4.jpg";